import React, { memo } from 'react'

import {
  MyName,
  MyDescription,
  MyExperience,
  MySkill,
  MyEducation,
  MyContact,
} from '../../component'
import { Separator } from '@/component'

import styles from './home.module.scss'

function HomePage() {
  return (
    <div className={styles.container}>
      <div className={styles.body_wrapper}>
        <MyName
          name="Vitaya Jealwarakun"
          description="I'm a software developer."
        />
        <Separator
          width="150px"
          height="5px"
          spacing="2rem"
        />
        <div className={styles.infomation__wrapper}>
          <div className={styles.information__section}>
            <MyDescription />
            <MySkill />
            <MyContact />
          </div>
          <div className={styles.information__section}>
            <MyExperience />
            <MyEducation />
          </div>
        </div>
      </div>
    </div>
  )
}

export default memo(HomePage)
